export default theme => ({
  loadMore: {
    border: '1px solid #ccc',
    background: '#eaeaea',
    fontSize: 12,
    width: '100%',
    padding: '10px 0',
    marginTop: 12,
    borderRadius: 3,
    cursor: 'pointer'
  },
  card: {
    minHeight: 100
  }
});